import { Component, OnInit, Inject } from '@angular/core';
import { constants } from "src/app/shared/common/contants";
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validationmethod } from "src/app/shared/common/validationmethod";
import { Actionbutton } from "src/app/shared/common/Actionbutton";

import { ActivatedRoute } from "@angular/router";
import { BasePopupComponent } from "src/app/user/base-popup/base-popup.component";
import { Router } from '@angular/router';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { LoginService } from 'src/app/shared/services/login.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { CommonTs } from 'src/app/shared/common/CommonTs';

@Component({
    selector: 'app-base-screen',
    templateUrl: './base-screen.component.html',
    styleUrls: ['./base-screen.component.scss'],
    standalone: false
})
export class BaseScreenComponent implements OnInit {

    gridAPI;

    lastPage;

    currentPage;

    nextPage;

    nextPagePlusOne;

    totalPages;

    gridColumnAPI;

    columnDefs;

    rowClassRules;

    defaultColDef;

    rowSelection;

    paginationPageSize;

    paginationNumberFormatter;

    pageSize;

    components: any;

    overlayNoRowsTemplate;

    listObjectDropDown: any = [];

    dynamicData = [];

    ngModelObject = [];

    ngModelObjectDivision = [];

    bootstrapColumn = 0;

    //dropDowns = [];

    retrieveObject: any = [];

    headerNameHtml = "";

    buttonName;

    tableName = "";

    tableID = "";

    agGridShow = false;

    retrieveNgModelCreation: any = [];

    screenType

    value;

    recordsStart = 0;

    backgroundColorScreen = "";

    //constructor
    constructor(
        private router: Router,
        private constants: constants,
        private validation: validationmethod,
        private commonTs: CommonTs,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private service: CommonService,
        private spinner: NgxUiLoaderService,
        private snackbar: MatSnackBar,
        private auth: LoginService,
        private localStorageSettings: LocalStorageSettingsService
    ) {

        //cell rendering in ag-grid
        this.components = {
            buttonRenderer: Actionbutton,
        }
        //if no rows , this message will display
        this.overlayNoRowsTemplate = this.constants.Norows;
    }

    async ngOnInit() {

        this.route.queryParams.subscribe(
            v => {
                this.spinner.start();
                console.log(v);
                this.tableName = v.tableName;
                console.log(this.tableName)
                this.headerNameHtml = v.headerNameHtml;
                this.screenType = v.screenType;
                console.log(this.screenType)
                this.spinner.stop();

            }
        )

        let retrieveNgModelCreation: any = [];

        retrieveNgModelCreation = await this.commonTs.ngModelObjectCreation(this.tableName);

        this.dynamicData = retrieveNgModelCreation[0];

        console.log(this.dynamicData);

        this.ngModelObject = retrieveNgModelCreation[1];

        console.log(this.ngModelObject);

        this.ngModelObjectDivision = retrieveNgModelCreation[2];

        console.log(this.ngModelObjectDivision);

        this.bootstrapColumn = retrieveNgModelCreation[3];

        console.log(this.bootstrapColumn);

        this.tableID = retrieveNgModelCreation[4];

        console.log(this.tableID);

        this.agGridShow = await retrieveNgModelCreation[5];

        // array to bind data to ag grid this.validation.equalto("password")
        this.columnDefs = [];

        this.columnDefs.push({
            headerName: "Action",
            filter: false,
            cellRenderer: "buttonRenderer",
            cellRendererParams: {
                edit: this.editIcon.bind(this),
                delete: this.deleteIcon.bind(this)
            },
            width: 150
        });

        this.columnDefs.push({
            headerName: 'Status',
            headerTooltip: 'Status',
            tooltipValueGetter: (params) => 'Status : ' + params.value,
            field: 'status',
            filter: 'agTextColumnFilter',
            width: 150
        });

        console.log(this.dynamicData);

        this.dynamicData.forEach(e => {

            if (e.agGridColumnShow) {

                let columnName = "";

                console.log(e.columnType);

                console.log(e.columnType == "valueDropDown");

                //if columntype is valueparentdropdown or valuedropdown or valueSelectListStatic then dropdownvalues are storing into columnname
                if (e.columnType == "valueParentDropDown" || e.columnType == "valueDropDown") {

                    columnName = e.dropDownValues;

                    console.log(columnName);

                }

                else if (e.columnType == "valueSelectListStatic") {

                    columnName = e.columnName.toString() + 1;

                    console.log(columnName);

                }

                else {

                    columnName = e.columnName;

                    console.log(columnName);

                }

                this.columnDefs.push({
                    headerName: e.displayAgGridColumnName,
                    headerTooltip: e.displayAgGridColumnName,
                    tooltipValueGetter: params => e.displayAgGridColumnName + " : " + params.value,
                    field: columnName,
                    filter: "agTextColumnFilter",
                    width: 180
                });

            }

        });

        // if the record has status==no , row color will change
        this.rowClassRules = {
            'rowBackgroundColor': function (params) {
                var numSickDays = params.node.data.status;
                return numSickDays === "No" || numSickDays === null;
            },
        };

        // below object is resizable, sorting and filter for ag-grid
        this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
            sortable: true,
            resizable: true,
            filter: true
        };

        this.rowSelection = this.constants.rowselection;
        this.paginationPageSize = this.constants.pagesize;
        this.paginationNumberFormatter = function (params) {
            return params.value.toLocaleString();
        };

        this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorA");

    }

    //excel export function
    onBtExport() {

        this.gridAPI.exportDataAsCsv();

    }

    //pagination code
    onPaginationChanged() {

        if (this.gridAPI) {

            this.lastPage = this.gridAPI.paginationIsLastPageFound();

            this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1

            this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1

            this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1

            this.totalPages = this.gridAPI.paginationGetTotalPages()

        }

    }

    //this function is for going to the given page number 
    onSearchChange(searchValue: number) {

        this.gridAPI.paginationGoToPage(searchValue - 1);

    }

    // below function is for changing the no of rows per page
    onPageSizeChanged(newPageSize) {

        var value = this.pageSize;

        this.gridAPI.setGridOption('paginationPageSize', Number(value));

    }

    // below function is for going to next page
    async onBtNext() {

        this.recordsStart = this.recordsStart + 100;

        this.retrieveObject = await this.commonTs.retrieve(this.tableName, this.listObjectDropDown, /*this.dropDowns,*/ this.ngModelObject, this.recordsStart);

        console.log(this.retrieveObject);

        if (this.retrieveObject.length == 0) {

            this.recordsStart = this.recordsStart - 100;

        }

        else {

            this.gridAPI.setGridOption('rowData', this.retrieveObject);

        }

        //this.gridAPI.paginationGoToNextPage();

    }

    // below function for going to previous page
    async onBtPrevious() {

        if (this.recordsStart > 0) {

            this.recordsStart = this.recordsStart - 100;

            this.retrieveObject = await this.commonTs.retrieve(this.tableName, this.listObjectDropDown, /*this.dropDowns,*/ this.ngModelObject, this.recordsStart);

            console.log(this.retrieveObject);

            this.gridAPI.setGridOption('rowData', this.retrieveObject);

        }

        //this.gridAPI.paginationGoToPreviousPage();

    }

    // below function for going to first page
    onBtFirst() {

        this.gridAPI.paginationGoToFirstPage();

    }

    // below function for going to last page
    onBtLast() {

        this.gridAPI.paginationGoToLastPage();

    }
    //pagination code ends

    // below function is to load the ag grid
    async onGridReady(params) {

        for (let i = 0; i < this.dynamicData.length; i++) {

            if (this.dynamicData[i].columnType == "valueDropDown" || this.dynamicData[i].columnType == "valueParentDropDown") {

                console.log(this.dynamicData[i].columnName);

                console.log(this.dynamicData[i]);

                /*this.dropDowns.push([this.dynamicData[i].columnName, this.dynamicData[i].dropDownIndex, this.dynamicData[i].agGridDecode, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues]);
        
                console.log(this.dropDowns);*/

                this.listObjectDropDown[this.dynamicData[i].dropDownIndex] = await this.commonTs.retrieveDropDown(this.dynamicData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues, this.dynamicData[i].dropdownLookupType);

                console.log(this.listObjectDropDown);

            }

            if (this.dynamicData[i].columnType == "valueSelectListStatic") {

                console.log(this.dynamicData[i].columnName);

                console.log(this.dynamicData[i]);

                this.listObjectDropDown[this.dynamicData[i].dropDownIndex] = await this.commonTs.retrieveDropDown(this.dynamicData[i].dropDownTableName, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues, this.dynamicData[i].dropdownLookupType);

                console.log(this.listObjectDropDown);

            }

        }

        this.gridAPI = params.api;

        this.gridColumnAPI = params.columnApi;

        //api call to get the location data
        await this.retrieve();

    }

    // Aggrid Edit function
    editIcon(e) {

        if (e.rowData.status == 'No' || e.rowData.status == null) {

            this.commonTs.checkingStatusSnackBar();

        } else {

            this.buttonName = this.constants.btnnameupdate;

            this.ngModelObject = this.commonTs.editIcon(this.ngModelObject, e.rowData);

            this.ngModelObject.forEach(inputObject => {

                if (inputObject.imageName != null && inputObject.keyValue != null) {

                    if ((inputObject.keyValue).length > 0) {

                        let extension: any;

                        if ((inputObject.keyValue).includes(".")) {

                            extension = (inputObject.keyValue).substring((inputObject.keyValue).lastIndexOf(".") + 1);

                            console.log(extension);

                        }

                        if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {

                            this.binaryFormatImage(inputObject);

                        }

                    }

                }

                if (inputObject.columnType == "valuePassword") {

                    if ((inputObject.keyValue != undefined) && (inputObject.keyValue != null)) {

                        if (inputObject.keyValue.toString() != "") {

                            console.log(inputObject.columnType);

                            inputObject.keyValue = inputObject.keyValue;

                        }

                    }

                }

            });

            console.log(e.rowData);

            console.log(this.ngModelObject);

            this.openForm("Update");

        }

    }

    async binaryFormatImage(inputObject) {

        let response = await this.service.downloadImage(inputObject.keyValue)

        console.log(response);

        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([response]);

        console.log(newBlob);

        var reader: FileReader = new FileReader();

        reader.onloadend = e => {

            console.log(reader.result);

            inputObject.keyValue = reader.result.toString();

            inputObject.imageShow = true;

            inputObject.imageShow1 = true;

            inputObject.binaryFormat = true;

        };
        reader.readAsDataURL(newBlob);

    }

    // Aggrid Delete function
    async deleteIcon(e) {

        if (e.rowData.status == 'No' || e.rowData.status == null) {

            this.commonTs.checkingStatusSnackBar();

        }

        else {

            if (confirm(this.constants.confirmDeletion) == true) {

                await this.commonTs.deleteIcon(e, this.tableName, this.ngModelObject, this.tableID);

                await this.retrieve();

            }

        }

    }

    async retrieve() {

        this.retrieveObject = await this.commonTs.retrieve(this.tableName, this.listObjectDropDown, /*this.dropDowns,*/ this.ngModelObject, this.recordsStart);

        console.log(this.retrieveObject);

        this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }

    openForm(buttonName) {

        this.buttonName = buttonName;

        let width = "80%";

        if (this.bootstrapColumn == 1) {

            width = "55%";

        }

        let dialogRef = this.dialog.open(BasePopupComponent, {
            maxWidth: '100vw',
            height: "90%",
            width: width,
            data: { ngModelObjectDivision: this.ngModelObjectDivision, ngModelObject: this.ngModelObject, tableName: this.tableName, dynamicData: this.dynamicData, retrieveObject: this.retrieveObject, buttonName: this.buttonName, listObjectDropDown: this.listObjectDropDown, bootstrapColumn: this.bootstrapColumn, tableID: this.tableID, update: "false", headerNameHtml: this.headerNameHtml },
            disableClose: true
        });

        // subcribe the popup after close
        dialogRef.afterClosed().subscribe(result => {

            console.log(result);

            //this.listObjectDropDown = result;

            this.retrieve();

        });

    }

}